<template>
  <div>
    <div class="moment-item-box">
      <TopNavbar title="详情" />
      <MomentStoryDetail
        :itemId="itemId"
        :key="'item_' + itemId"
        :showAvatar="false"
        @changeItem="handleChangeItem"
      />

      <div class="comment-cell" :key="itemId">
        <CommentInputBox @onClickComment="onClickCommentBox"></CommentInputBox>
        <CommentInfo
          ref="comment"
          :showInputBox="false"
          :itemId="itemId"
        ></CommentInfo>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/components/common/TopNavbar.vue";
import MomentStoryDetail from "./MomentStoryDetail.vue";
import CommentInputBox from "@/components/comment/CommentInputBox.vue";
import CommentInfo from "@/components/comment/CommentInfo.vue";
export default {
  components: {
    MomentStoryDetail,
    TopNavbar,
    CommentInputBox,
    CommentInfo,
  },
  name: "MomentPageLite",
  data() {
    return {
      itemId: 0,
    };
  },
  mounted() {},
  activated() {
    let itemId = parseInt(this.$route.params.id);
    if (itemId) {
      this.itemId = itemId;
    }
  },
  methods: {
    onClickCommentBox() {
      this.$refs.comment.onClickComment()
    },
    handleChangeItem(itemId) {
      this.itemId = itemId;
      this.scrollTop()
    },
    scrollTop() {
      window.scrollTo(0, 0);
    }
  },
};
</script>
